import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function AddUserNote() {
  const navigate = useNavigate();
  const users = ['Ryan Loeding', 'Veronica Barragan', 'Jim Hunt', 'Ted Araya', 'Timothy Rehrmann', 'Chuck Kaye', 'William Kline', 'Shauna Gliss', 'Paul Boyle', 'Zachary Gunnell', 'Nicolas Kraus', 'Lorraine MacGregor'];
  return <div className="space-y-4" data-id="element-299" data-mp="3oas9ro5jwhao">
      <div className="flex items-center justify-between" data-id="element-300" data-mp="3obk8v8ycwx5p">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-301" data-mp="5wjem5tdpp10">Add User Note</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/users')} data-id="element-302" data-mp="159oz57tylp4">
          ← Back to Users
        </Button>
      </div>

      <Card data-id="element-303" data-mp="34k5pne4mjf7u">
        <CardContent className="pt-6" data-id="element-304" data-mp="mdz236l5ilvq">
          <form className="space-y-4 max-w-sm" data-id="element-305" data-mp="mcxtr9visdhp">
            <div data-id="element-306" data-mp="mc4q4hruy43s">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-307" data-mp="rcsj38zncv0n">
                User
              </label>
              <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[180px]" data-id="element-308" data-mp="w4tqaghyjvjt">
                {users.map(u => <option key={u} data-id="element-309" data-mp="3g4y56yvr0k7">{u}</option>)}
              </select>
            </div>
            <div data-id="element-310" data-mp="8f93tnmlig5s">
              <label className="block text-sm font-medium text-slate-700 mb-1" data-id="element-311" data-mp="8epx732ebe72">
                Notes
              </label>
              <textarea className="w-full min-h-[100px] rounded border border-slate-300 bg-white p-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-y" data-id="element-312" data-mp="dfnfrgrbia93" />
            </div>
            <div className="pt-1" data-id="element-313" data-mp="1ouit8ze8a5o2">
              <Button type="submit" data-id="element-314" data-mp="1stroy9stwdm9">Submit</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>;
}